import { Link } from "react-router-dom";

const STATS = [
  { value: "30+", label: "影视作品", icon: "ri-file-list-3-line" },
  { value: "60+", label: "角色分析", icon: "ri-user-star-line" },
  { value: "每日", label: "资讯更新", icon: "ri-newspaper-line" },
  { value: "全类型", label: "题材覆盖", icon: "ri-layout-grid-line" }
];

export default function SiteIntro() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-20 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1.5 text-xs font-medium text-primary-700">
              <i className="ri-quill-pen-line"></i>
              关于亲吻姐姐
            </span>
            <h2 className="mt-4 font-heading text-2xl font-extrabold leading-snug text-foreground-950 md:text-3xl">
              我们不做浅尝辄止的安利，
              <br className="hidden md:block" />
              只做值得被读懂的解析。
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
              亲吻姐姐专注影视剧资讯、剧情介绍与角色分析。我们用清晰的脉络梳理剧情发展，用理性的视角拆解角色动机，
              帮助你在观影之外，真正看懂一部作品想说却没说出口的话。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              覆盖电影、电视剧、网络剧等多种类型，无论你是追剧党还是剧情考据爱好者，都能在这里找到所需。
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                了解我们
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
              >
                <i className="ri-mail-send-line"></i>
                投稿与反馈
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-5">
            {STATS.map((stat) => (
              <div key={stat.label} className="rounded-xl border border-background-200 bg-background-50 p-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                  <i className={`${stat.icon} text-xl`}></i>
                </span>
                <p className="mt-4 font-heading text-3xl font-extrabold text-foreground-950">{stat.value}</p>
                <p className="mt-1 text-sm text-foreground-600">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}